import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { components } from '../components';

const termsAndConditions = [
    {
    id: 1,
    title: '1. Tenant Cancellation Policy',
    content: `
      If the tenant requests to cancel the booking before the move-in date, 
      the token amount will be refunded after deducting the applicable 
      platform fee and taxes. 
      
      These terms and conditions will be displayed on the booking page, 
      and the user must confirm and agree to them before proceeding with the booking. 
      This flexible policy aims to enhance user convenience and increase booking conversions.
    `,
  },
  {
    id: 2,
    title: '2. Booking Confirmation by Property Manager',
    content: `
      If the Property Manager does not accept the booking within 24 hours, 
      automatic reminders will be sent to confirm the booking.
      If the Property Manager cancels the booking due to full occupancy 
      or any other valid reason, the booking amount will be refunded 
      after deducting applicable platform fees, service charges, and taxes.
    `,
  }, 
  {
    id: 3,
    title: '3. Acceptance of Terms',
    content: `
      By proceeding with a booking, you acknowledge and agree to these terms 
      and conditions, including the refund and cancellation policies outlined above.
    `,
  },
];

export const PaymentTermsAndConditions: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const renderHeader = (): JSX.Element => {
        return <components.Header title="Payment Terms & Conditions" goBack={true} />;
    };

    const renderContent = (): JSX.Element => {
        return (
            <main className="container" style={{ paddingBottom: 0 }}>
                <div style={{ marginTop: '10%', marginBottom: 20 }}>
                    {termsAndConditions.map((item) => (
                        <div key={item.id} style={{ marginBottom: '10%' }}>
                            <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
                            <text.T14>{item.content}</text.T14>
                        </div>
                    ))}
                </div>
            </main>
        );
    };

    return (
        <>
            {renderHeader()}
            {renderContent()}
        </>
    );
};
